// src/utils/auth.js
export function isTokenExpired(token) {
  // If no token is provided, check localStorage
  const checkToken = token || localStorage.getItem("user_token");

  // Since we don't have a reliable expiration timestamp from the current API response,
  // we consider the token valid as long as it exists.
  return !checkToken;
}
